var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:email-sent-outline",
    clipPath: "url(#clip0_276_1902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5806 4.125H6.83057C6.00557 4.125 5.33057 4.8 5.33057 5.625V12.375C5.33057 12.7728 5.4886 13.1544 5.76991 13.4357C6.05121 13.717 6.43274 13.875 6.83057 13.875H16.5806C17.4131 13.875 18.0806 13.2075 18.0806 12.375V5.625C18.0806 5.22718 17.9225 4.84564 17.6412 4.56434C17.3599 4.28304 16.9784 4.125 16.5806 4.125ZM16.5806 12.375H6.83057V6.8775L11.7056 9.375L16.5806 6.8775V12.375ZM11.7056 8.1075L6.83057 5.625H16.5806L11.7056 8.1075ZM3.83057 12.375C3.83057 12.5025 3.85307 12.6225 3.86807 12.75H0.830566C0.416566 12.75 0.0805664 12.4125 0.0805664 12C0.0805664 11.5875 0.416566 11.25 0.830566 11.25H3.83057V12.375ZM2.33057 5.25H3.86807C3.85307 5.3775 3.83057 5.4975 3.83057 5.625V6.75H2.33057C1.91807 6.75 1.58057 6.4125 1.58057 6C1.58057 5.5875 1.91807 5.25 2.33057 5.25ZM0.830566 9C0.830566 8.5875 1.16807 8.25 1.58057 8.25H3.83057V9.75H1.58057C1.16807 9.75 0.830566 9.4125 0.830566 9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_1902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.0805664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCase);
export default __webpack_public_path__ + "static/media/sendCase.a2bd1ba317d7737add278be0c990b97d.svg";
export { ForwardRef as ReactComponent };